import { parseTimeTo24h, format24hHM } from '../scheduleTimeDisplay';

// Excel stores a time of day as a fraction of a 24-hour day (0.5 === 12:00).
// SheetJS's cellDates:true turns real time cells into JS Dates, but a cell the
// sheet formats as a plain number still arrives here as the raw fraction.
function fromDayFraction(value) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return null;
  const frac = value - Math.floor(value); // a full datetime serial carries a date part too
  if (frac < 0) return null;
  const totalMinutes = Math.round(frac * 24 * 60);
  if (totalMinutes >= 24 * 60) return null; // rounding landed on midnight of the next day
  return { h: Math.floor(totalMinutes / 60), m: totalMinutes % 60 };
}

// Arbitrary spreadsheet time -> the 24-hour "HH:MM" the schedule stores.
// Returns null rather than guessing: an unreadable time must surface as "no time"
// instead of silently becoming midnight.
//
// Deliberately does NOT snap to quarter hours. convertScheduledTime already snaps
// for display, so snapping on write would throw away a real 9:05 appointment.
export function normalizeImportedTime(value) {
  if (value == null || value === '') return null;

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return format24hHM(value.getHours(), value.getMinutes());
  }

  if (typeof value === 'number') {
    const parts = fromDayFraction(value);
    return parts ? format24hHM(parts.h, parts.m) : null;
  }

  const parts = parseTimeTo24h(String(value));
  if (!parts) return null;
  // parseTimeTo24h's 24-hour branch accepts any leading digits, so "25:00" gets
  // through as {h:25}. Reject out-of-range values here.
  if (parts.h < 0 || parts.h > 23 || parts.m < 0 || parts.m > 59) return null;
  return format24hHM(parts.h, parts.m);
}
